import React from "react";

function InoviceModal() {
    return (
        <React.Fragment>
            {/* Edit Invoice Modal */}
            <div id="invoice-modal" className="modal fade" tabindex="-1" aria-hidden="true">
                <div className="modal-dialog">
                    <div className="modal-content">
                        {/* <!-- BEGIN: Modal Header --> */}
                        <div className="modal-header">
                            <h2 className="fw-medium fs-base me-auto">Invoice</h2>
                        </div>
                        {/* </div> <!-- END: Modal Header --> */}
                        {/* <!-- BEGIN: Modal Body --> */}
                        <div className="modal-body">
                            <form>
                                <div className="grid columns-12">
                                    <div className="intro-y g-col-6">
                                        <label for="invoice_id" className="form-label">Invoice ID :</label>
                                        <input id="invoice_id" name="invoice_id" type="text" required className="form-control" placeholder="Enter Invoice ID" />
                                    </div>
                                    <div className="intro-y g-col-6">
                                        <label for="invoice_no" className="form-label">Invoice No. :</label>
                                        <input id="invoice_no" name="invoice_no" type="text" required className="form-control" placeholder="Enter Invoice No." />
                                    </div>
                                    <div className="intro-y g-col-6">
                                        <label for="date" className="form-label"> Date :</label>
                                        <div className="input-group mx-auto ">
                                            <div id="input-group-email" className="input-group-text "> <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="feather feather-calendar w-4 h-4"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect><line x1="16" y1="2" x2="16" y2="6"></line><line x1="8" y1="2" x2="8" y2="6"></line><line x1="3" y1="10" x2="21" y2="10"></line></svg> </div> <input type="text" placeholder="Enter  Date" id="date" name="date" className="datepicker form-control " data-single-mode="true" />
                                        </div>
                                    </div>
                                    <div className="intro-y g-col-12 g-col-sm-6">
                                        <label for="time" className="form-label"> Time :</label>
                                        <input id="time" name="time" type="text" className="form-control" placeholder="Enter Time" />
                                    </div>
                                    <div className="intro-y g-col-12 g-col-sm-12">
                                        <label for="note" className="form-label">Note :</label>
                                        <textarea id="note" name="note" rows={5} className="form-control" placeholder="Enter Note" />
                                    </div>
                                    <div className="intro-y g-col-12 g-col-sm-12 d-flex flex-column justify-items-center">
                                        <label for="lump_sum" className="form-label">Lump Sum :</label>
                                        <div className="mt-2">
                                            <div className="form-check form-switch"> <input id="checkbox-switch-7" className="form-check-input" type="checkbox" /></div>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                        {/* <!-- END: Modal Body --> */}
                        {/* <!-- BEGIN: Modal Footer --> */}
                        <div className="modal-footer text-end"> <button type="button" data-bs-dismiss="modal" className="btn btn-outline-secondary w-20 me-1">Cancel</button> <button type="button" className="btn btn-primary w-20">Save</button> </div>
                    </div>
                </div>
            </div>
            {/*End Edit Invoice Modal */}
        </React.Fragment>
    )
}

export default InoviceModal;